<div *ngIf="isLoaderShowing" class="loader-wrapper">
    <div class="loader-spinner center csc-primary-color-white">
        <img [src]="loaderImagePath" class="loader-image">
        <p>Loading</p>
    </div>
</div>